import { render, staticRenderFns } from "./iconModal.vue?vue&type=template&id=0654f73c&scoped=true&"
import script from "./iconModal.vue?vue&type=script&lang=js&"
export * from "./iconModal.vue?vue&type=script&lang=js&"
import style0 from "./iconModal.vue?vue&type=style&index=0&id=0654f73c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0654f73c",
  null
  
)

export default component.exports